import { getLanguageCode } from "web/Layout/Translations/LanguageWrapper";
import { IGtm } from "web/types/Gtm";

const buildGtmPayload = (params: {
  eventName: string;
  url?: string;
  options: IGtm;
  resolvedOneKcId?: string | null;
}) => {
  const { eventName, url, options, resolvedOneKcId } = params;

  const base = {
    event: eventName,
    ...(url ? { url } : {}),
    ...options,
  };

  if (eventName === "virtualPageView") {
    const onekc = options.onekc_id ?? resolvedOneKcId;
    const language = getLanguageCode();
    return {
      ...base,
      ...(onekc ? { onekc_id: onekc } : {}),
      ...(language ? { current_language: language?.toUpperCase() || "PL" } : {}),
    };
  }

  return base;
};

export default buildGtmPayload;
